import { createActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';
import registrationApi from '../../../api/registrationApi';
import urlUtils from '../../../utils/urlutils';

export const {
  showMainLoading,
  hideMainLoading,
  showMainLoadingAsSuccess,
  resetInvitationCode,
  setInvitationCode,
  resetInviterRole,
  setInviterRole,
  setPortal,
  getStartupConfigFulfilled,
  getStartupConfigPending,
  getStartupConfigRejected,
  setInvitedStatus,
  setBrokerInvitedStatus,
  setJourneyAccountType,
} = createActions(
  actionTypes.SHOW_MAIN_LOADING,
  actionTypes.HIDE_MAIN_LOADING,
  actionTypes.SHOW_MAIN_LOADING_AS_SUCCESS,
  actionTypes.RESET_INVITATION_CODE,
  actionTypes.SET_INVITATION_CODE,
  actionTypes.RESET_INVITER_ROLE,
  actionTypes.SET_INVITER_ROLE,
  actionTypes.SET_PORTAL,
  actionTypes.GET_STARTUP_CONFIG_FULFILLED,
  actionTypes.GET_STARTUP_CONFIG_PENDING,
  actionTypes.GET_STARTUP_CONFIG_REJECTED,
  actionTypes.SET_INVITED_STATUS,
  actionTypes.SET_BROKER_INVITED_STATUS,
  actionTypes.SET_JOURNEY_ACCOUNT_TYPE,
  getActionOptions(ACTION_PREFIX),
);

export const getStartupConfig = () => (dispatch) => {
  dispatch(getStartupConfigPending());

  const getConfig = registrationApi.getStartupConfig;

  return getConfig()
    .then((response) => {
      dispatch(getStartupConfigFulfilled(response));
      dispatch(
        setJourneyAccountType({ userJourneyAccountType: urlUtils.getUserJourneyAccountType() }),
      );
      return true;
    })
    .catch((error) => {
      dispatch(getStartupConfigRejected(error));
      return false;
    });
};
